import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import InputText from '../../../components/inputComponents/InputText';
import { GlobalContext } from '../../../components/contexts';

const ConsultFlfmtWrite = ({ rslt, onChangeRslt, svcObj }) => {
  const [tables, setTables] = useState([]);
  const [valueObj, setValueObj] = useState({ ...rslt });
  const store = useContext(GlobalContext);

  useEffect(() => {
    if (rslt.improvementList && rslt.improvementList.length > 0) {
      setTables(
        rslt.improvementList.map(improvement => ({
          key: improvement.exprtCnsltDtlId || improvement.key,
          menuIndex: rslt.index,
          valueObj: { ...improvement, key: improvement.exprtCnsltDtlId },
        }))
      );
    } else {
      setTables([
        {
          key: Date.now(),
          menuIndex: rslt.index,
          valueObj: {
            ...rslt,
            riskDcrsYn: 'N',
            techYn: 'N',
            mngYn: 'N',
            etcYn: 'N',
            flfmtYn: '',
            cnsltCn: '',
            flfmtCn: '',
          },
        },
      ]);
    }
  }, [rslt]);

  const menuIndex = rslt.index;
  const onChangeTableValue = (index, model, value) => {
    const updatedTables = tables.map((table, i) =>
      i === index
        ? { ...table, valueObj: { ...table.valueObj, [model]: value } }
        : table
    );
    setTables(updatedTables);
    onChangeRslt && onChangeRslt(menuIndex, index, model, value, updatedTables);
  };

  return (
    <>
      <div className="data-table">
        <table>
          <caption>단위 작업에 해당되는 근본원인 및 문제점 내용입니다.</caption>
          <tbody>
            <tr>
              <td className="bg--skyblue">
                <span className="txt--red">*</span> 근본원인
              </td>
              <td className="form-check">
                <input
                  type="checkbox"
                  id="humanFactor"
                  name="humanFactor"
                  checked={valueObj.anlsPrYn === 'Y'}
                  className={'readOnly'}
                  disabled
                  onChange={e => {
                    onChangeValueObj('anlsPrYn', e.target.checked ? 'Y' : 'N');
                  }}
                />
                <label htmlFor="humanFactor">인적요인</label>
              </td>
              <td className="form-check">
                <input
                  type="checkbox"
                  id="materialFactor"
                  name="materialFactor"
                  checked={valueObj.anlsPhyYn === 'Y'}
                  className={'readOnly'}
                  disabled
                  onChange={e => {
                    onChangeValueObj('anlsPhyYn', e.target.checked ? 'Y' : 'N');
                  }}
                />
                <label htmlFor="materialFactor">물적·설비적 요인</label>
              </td>
              <td className="form-check">
                <input
                  type="checkbox"
                  id="environFactor"
                  name="environFactor"
                  checked={valueObj.anlsEnvYn === 'Y'}
                  className={'readOnly'}
                  disabled
                  onChange={e => {
                    onChangeValueObj('anlsEnvYn', e.target.checked ? 'Y' : 'N');
                  }}
                />
                <label htmlFor="environFactor">환경적 요인</label>
              </td>
            </tr>
            <tr>
              <td className="bg--skyblue">
                <span className="txt--red">*</span> 현황 및 문제점
              </td>
              <td colSpan={3}>
                <textarea
                  aria-label="현황 및 문제점"
                  className="form-control sm"
                  style={{ height: '20rem', lineHeight: '1.5' }}
                  value={valueObj.anlsCn}
                  required={true}
                  readOnly={true}
                  maxLength={4000}
                  onChange={e => {
                    onChangeValueObj('anlsCn', e.target.value);
                  }}
                ></textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="data-table" style={{ marginTop: '60px' }}>
        {tables.map((table, index) => (
          <table key={table.key}>
            <caption>컨설팅 개선방안 및 개선사항을 나타내는 표입니다.</caption>
            <tbody>
              <tr>
                <td className="bg--skyblue">
                  <span className="txt--red">*</span> 개선 방안
                </td>
                <td className="form-check">
                  <input
                    type="checkbox"
                    id={`unRisk-${index}`}
                    name="unRisk"
                    checked={table.valueObj.riskDcrsYn === 'Y'}
                    className={'readOnly'}
                    disabled
                    onChange={e =>
                      onChangeTableValue(
                        index,
                        'riskDcrsYn',
                        e.target.checked ? 'Y' : 'N'
                      )
                    }
                  />
                  <label htmlFor={`unRisk-${index}`}>위험성 제거/저감</label>
                </td>
                <td className="form-check">
                  <input
                    type="checkbox"
                    id={`tech-${index}`}
                    name="tech"
                    checked={table.valueObj.techYn === 'Y'}
                    className={'readOnly'}
                    disabled
                    onChange={e =>
                      onChangeTableValue(
                        index,
                        'techYn',
                        e.target.checked ? 'Y' : 'N'
                      )
                    }
                  />
                  <label htmlFor={`tech-${index}`}>기술적</label>
                </td>
                <td className="form-check">
                  <input
                    type="checkbox"
                    id={`manage-${index}`}
                    name="manage"
                    checked={table.valueObj.mngYn === 'Y'}
                    className={'readOnly'}
                    disabled
                    onChange={e =>
                      onChangeTableValue(
                        index,
                        'mngYn',
                        e.target.checked ? 'Y' : 'N'
                      )
                    }
                  />
                  <label htmlFor={`manage-${index}`}>관리적</label>
                </td>
                <td className="form-check">
                  <input
                    type="checkbox"
                    id={`etc-${index}`}
                    name="etc"
                    checked={table.valueObj.etcYn === 'Y'}
                    className={'readOnly'}
                    disabled
                    onChange={e =>
                      onChangeTableValue(
                        index,
                        'etcYn',
                        e.target.checked ? 'Y' : 'N'
                      )
                    }
                  />
                  <label htmlFor={`etc-${index}`}>기타, 보호구 등</label>
                </td>
              </tr>
              <tr>
                <td className="bg--skyblue">
                  <span className="txt--red">*</span> 개선 사항
                  <br />(
                  {table.valueObj.cnsltCn ? table.valueObj.cnsltCn.length : 0} /
                  4000)
                </td>
                <td colSpan={4}>
                  <textarea
                    aria-label="개선 사항"
                    className="form-control sm"
                    style={{ height: '10rem', lineHeight: '1.5' }}
                    value={table.valueObj.cnsltCn || ''}
                    required={true}
                    readOnly={true}
                    maxLength={4000}
                    onChange={e => {
                      onChangeTableValue(index, 'cnsltCn', e.target.value);
                    }}
                  ></textarea>
                </td>
              </tr>

              {
                <tr>
                  <td className="bg--skyblue">
                    <span className="txt--red">*</span> 수행 사항
                    <br />(
                    {table.valueObj.flfmtCn
                      ? table.valueObj.flfmtCn.length
                      : 0}{' '}
                    / 4000)
                  </td>
                  <td colSpan={4}>
                    {(store.store?.authrtId === 'EX' &&
                      svcObj.cnsltSttsCd === 'CNSLT02') ||
                    rslt.vldAplyStts == null ||
                    rslt.vldAplyStts != 'C' ? (
                      <textarea
                        aria-label="수행 사항"
                        className="form-control sm"
                        style={{ height: '10rem', lineHeight: '1.5' }}
                        value={''}
                        required={true}
                        readOnly={true}
                        maxLength={4000}
                        onChange={e => {
                          onChangeTableValue(index, 'flfmtCn', e.target.value);
                        }}
                      ></textarea>
                    ) : (
                      <textarea
                        aria-label="수행 사항"
                        className="form-control sm"
                        style={{ height: '10rem', lineHeight: '1.5' }}
                        value={table.valueObj.flfmtCn || ''}
                        required={true}
                        readOnly={
                          svcObj.cnsltSttsCd != 'CNSLT02' ||
                          store.store?.authrtId == 'EX'
                        }
                        maxLength={4000}
                        onChange={e => {
                          onChangeTableValue(index, 'flfmtCn', e.target.value);
                        }}
                      ></textarea>
                    )}
                  </td>
                </tr>
              }
              <tr>
                <td className="bg--skyblue">
                  <span className="txt--red">*</span> 수행 여부
                </td>
                <td className="form-check">
                  {store.store?.authrtId != 'EX' &&
                  svcObj.cnsltSttsCd === 'CNSLT03' ? (
                    <input
                      type="radio"
                      id={`flfmtY-${index}`}
                      name={`flfmt-${index}`} // 같은 그룹으로 설정
                      value="Y"
                      disabled={
                        svcObj.cnsltSttsCd != 'CNSLT03' ||
                        store.store?.authrtId != 'EX'
                      }
                      className={'readOnly'}
                      checked={''}
                      onChange={e =>
                        onChangeTableValue(index, 'flfmtYn', e.target.value)
                      }
                    />
                  ) : (
                    <input
                      type="radio"
                      id={`flfmtY-${index}`}
                      name={`flfmt-${index}`} // 같은 그룹으로 설정
                      value="Y"
                      disabled={
                        svcObj.cnsltSttsCd != 'CNSLT03' ||
                        store.store?.authrtId != 'EX'
                      }
                      className={'readOnly'}
                      checked={table.valueObj.flfmtYn === 'Y'}
                      onChange={e =>
                        onChangeTableValue(index, 'flfmtYn', e.target.value)
                      }
                    />
                  )}

                  <label htmlFor={`flfmtY-${index}`}>예</label>
                </td>
                <td className="form-check">
                  {store.store?.authrtId != 'EX' &&
                  svcObj.cnsltSttsCd === 'CNSLT03' ? (
                    <input
                      type="radio"
                      id={`flfmtN-${index}`}
                      name={`flfmt-${index}`} // 같은 그룹으로 설정
                      value="N"
                      disabled={
                        svcObj.cnsltSttsCd != 'CNSLT03' ||
                        store.store?.authrtId != 'EX'
                      }
                      className={'readOnly'}
                      checked={''}
                      onChange={e =>
                        onChangeTableValue(index, 'flfmtYn', e.target.value)
                      }
                    />
                  ) : (
                    <input
                      type="radio"
                      id={`flfmtN-${index}`}
                      name={`flfmt-${index}`} // 같은 그룹으로 설정
                      value="N"
                      disabled={
                        svcObj.cnsltSttsCd != 'CNSLT03' ||
                        store.store?.authrtId != 'EX'
                      }
                      className={'readOnly'}
                      checked={table.valueObj.flfmtYn === 'N'}
                      onChange={e =>
                        onChangeTableValue(index, 'flfmtYn', e.target.value)
                      }
                    />
                  )}
                  <label htmlFor={`flfmtN-${index}`}>아니오</label>
                </td>
                <td colSpan={2}></td>
              </tr>
            </tbody>
          </table>
        ))}
      </div>

      {/* <p>- 관련 법조항 표기</p>
      <p>- 참고자료 출처 표기</p> */}
    </>
  );
};

export default ConsultFlfmtWrite;
